import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
// @ts-ignore
import styles from './agendamento_futevolei_arenamajubarretos.module.scss';

const WA = '5516991414590';
const WA_TEXT = 'Olá! Vim pelo link da bio e gostaria de mais informações sobre as aulas de futevôlei.';

const PROFESSORES = [
    { nome: 'Celcinho', tag: 'FTV' },
    { nome: 'Boto', tag: 'FTV' },
    { nome: 'Ana Júlia', tag: 'FTV' },
];

function buildWhatsAppUrl() {
    return `https://wa.me/${WA}?text=${encodeURIComponent(WA_TEXT)}`;
}

const Agendamento_futevolei_arenamajubarretos: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.agendamento_futevolei_arenamajubarretos}>
            <div className={styles.inner}>
                <div className={styles.header}>
                    <Link to="/arenamajubarretos" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h1 className={styles.title}>Futevôlei</h1>
                </div>

                <p className={styles.text}>
                    Para agendar sua aula, fale com a gente no WhatsApp. Você também pode conferir abaixo quem são os
                    professores que vão te acompanhar nos treinos.
                </p>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>Nossos professores</h2>
                    <div className={styles.professoresGrid}>
                        {PROFESSORES.map((p) => (
                            <div key={p.nome} className={styles.professorCard}>
                                <div className={styles.professorName}>{p.nome}</div>
                                <div className={styles.professorTag}>{p.tag}</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className={styles.hero}>
                    <img
                        className={styles.heroImg}
                        src={require('./src/professores.png')}
                        alt="Professores do futevôlei"
                        loading="lazy"
                    />
                </div>

                <a href={buildWhatsAppUrl()} className={styles.cta} target="_blank" rel="noopener noreferrer">
                    Chamar no WhatsApp
                </a>
            </div>
        </div>
    );
};

export default Agendamento_futevolei_arenamajubarretos;
